<template>
    <div class="tech-skills">
        <div class="tech-groups">
            <div v-for="group in skills" :key="group.id" class="tech-group">
                <h3 class="tech-group-title">{{ group.title }}</h3>
                <div class="tech-items">
                    <div v-for="tech in group.list" :key="tech.id" class="tech-item">
                        <div class="tech-icon">
                            <img :src="`/assets/img/${tech.image}`" :alt="tech.title">
                        </div>
                        <span class="tech-name">{{ tech.title }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TechSkills',
    props: {
        skills: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.tech-skills {
    width: 100%;
}

.tech-groups {
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
    justify-content: space-between;
}

.tech-group {
    flex: 1 1 calc(50% - 25px);
    min-width: 300px;
}

.tech-group-title {
    font-size: 16px;
    font-weight: 700;
    color: #ff6b6b;
    margin: 0 0 25px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding-bottom: 12px;
    border-bottom: 2px solid rgba(255, 107, 107, 0.2);
}

.tech-items {
    display: flex;
    flex-wrap: wrap;
    gap: 25px;
    align-items: flex-start;
}

.tech-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    transition: all 0.3s ease;
    padding: 15px;
    border-radius: 12px;
    background: #1a1d29;
    border: 1px solid transparent;
    min-width: 90px;
}

.tech-item:hover {
    transform: translateY(-5px);
    background: #212430;
    border-color: rgba(255, 107, 107, 0.3);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.tech-icon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255);
    border-radius: 12px;
    padding: 10px;
    transition: all 0.3s ease;
}

.tech-item:hover .tech-icon {
    background: rgba(255, 255, 255);
    transform: scale(1.1);
}

.tech-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.tech-name {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    line-height: 1.3;
}

/* Responsive */
@media (max-width: 1024px) {
    .tech-groups {
        gap: 40px;
    }

    .tech-group {
        flex: 1 1 calc(50% - 20px);
    }

    .tech-items {
        gap: 20px;
    }
}

@media (max-width: 768px) {
    .tech-groups {
        gap: 35px;
    }

    .tech-group {
        flex: 1 1 100%;
        min-width: 0;
    }

    .tech-group-title {
        font-size: 15px;
        margin-bottom: 20px;
    }

    .tech-items {
        gap: 18px;
        justify-content: center;
    }

    .tech-item {
        min-width: 80px;
        padding: 12px;
    }

    .tech-icon {
        width: 50px;
        height: 50px;
    }

    .tech-name {
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .tech-groups {
        gap: 30px;
    }

    .tech-items {
        gap: 15px;
    }

    .tech-item {
        min-width: 70px;
        padding: 10px;
    }

    .tech-icon {
        width: 45px;
        height: 45px;
    }

    .tech-name {
        font-size: 11px;
    }
}
</style>
